"use client";

import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

interface ErrorCardProps {
  error: Error;
}

export default function ErrorCard({ error }: ErrorCardProps) {
  const [isStackVisible, setIsStackVisible] = useState(false);

  return (
    <div className="w-full max-w-2xl overflow-hidden rounded-lg bg-white shadow-md dark:bg-gray-800">
      <div className="p-6">
        <h2 className="mb-4 text-2xl font-bold text-red-600 dark:text-red-400">{error.name || "Error"}</h2>
        {error.message && <p className="mb-4 text-gray-700 dark:text-gray-300">{error.message || "No message"}</p>}
        {!!error.cause && (
          <div className="mb-4">
            <h3 className="mb-2 text-lg font-semibold text-gray-800 dark:text-gray-200">Cause:</h3>
            <p className="text-gray-700 dark:text-gray-300">{error.cause.toString()}</p>
          </div>
        )}
        {error.stack && (
          <div>
            <button
              className="flex items-center text-blue-600 hover:underline focus:outline-none dark:text-blue-400"
              onClick={() => setIsStackVisible(!isStackVisible)}
            >
              {isStackVisible ? (
                <>
                  <ChevronUp className="mr-1 h-4 w-4" />
                  Hide Stack Trace
                </>
              ) : (
                <>
                  <ChevronDown className="mr-1 h-4 w-4" />
                  Show Stack Trace
                </>
              )}
            </button>
            {isStackVisible && <pre className="mt-2 overflow-x-auto rounded bg-gray-100 p-4 text-sm dark:bg-gray-700">{error.stack}</pre>}
          </div>
        )}
      </div>
    </div>
  );
}
